import * as ActionType from '../../constants/actionType';
import {LicenseStatus} from '../../constants/dataEnum';

const initialState = {
  showModal: false,
  showCountdown: false,
  status: LicenseStatus.NO_LICENSE,
  modifiedDate: null,
  expiredDate: null,
  clientID: null,
  remainingDays: 0,
  isTessaraInstrument: false,
};

export default function licenseState(state = initialState, action = '') {
  switch (action.type) {
    case ActionType.SHOW_LICENSE_MODAL:
      return {...state, showModal: true};
    case ActionType.HIDE_LICENSE_MODAL:
      return {...state, showModal: false};
    case ActionType.SHOW_LICENSE_COUNTDOWN:
      return {...state, showCountdown: true};
    case ActionType.HIDE_LICENSE_COUNTDOWN:
      return {...state, showCountdown: false};
    case ActionType.SET_TESSARA_LICENSE:
      return {...state, isTessaraInstrument: action.isTessaraInstrument};
    case ActionType.SET_LICENSE: {
      const {remainingTime} = action.data;
      let remainingDays = remainingTime ? remainingTime?.split('.')[0] : null;
      if (remainingTime && remainingDays.includes(':')) {
        remainingDays = 0;
      } else {
        remainingDays = parseInt(remainingDays, 10);
      }
      return {
        ...state,
        status: action.data.status,
        modifiedDate: action.data?.modifiedDate || null,
        expiredDate: action.data?.expiryDate || null,
        clientID: action.data?.clientId || null,
        remainingDays,
        isTessaraInstrument: action.data?.isTessaraInstrument,
      };
    }
    default:
      return state;
  }
}
